import img_title from "../../img/messages/title.png";
import img_top_illust from "../../img/messages/top_illust.png";
import img_heart1 from "../../img/messages/heart1.png";
import img_heart2 from "../../img/messages/heart2.png";
import img_heart3 from "../../img/messages/heart3.png";
import img_heart4 from "../../img/messages/heart4.png";
import "./MessagesFrontispiece.scoped.scss";

interface Props {}

export default function MessagesFrontispiece(props: Props) {
  return (
    <div className="relative max-w-3xl mx-5 my-8 bg-white rounded-3xl">
      <div className="flex items-center justify-center">
        <div className="w-1/3">
          <img className="" src={img_title} alt="タイトル" />
        </div>
        <div className="w-1/3">
          <img className="" src={img_top_illust} alt="扉絵" />
        </div>
        <div className="z-10 w-1/3">
          <div className="p-4 text-sm text-red-700 select-none md:text-2xl description">
            陽だまりに集まる猫さんたちからたくさんの
            <br className="hidden" />
            メッセージをお預かりしました。
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 w-full">
        <div className="relative w-full">
          <div className="absolute bottom-0 w-10 sm:w-14 md:left-8 left-5">
            <img src={img_heart1} alt="heart1"></img>
          </div>
          <div className="absolute bottom-0 w-10 sm:w-14 left-20 sm:left-24 md:left-32">
            <img src={img_heart2} alt="heart2"></img>
          </div>
          <div className="absolute bottom-0 w-10 sm:w-14 sm:right-24 right-20 md:right-36">
            <img src={img_heart3} alt="heart3"></img>
          </div>
          <div className="absolute bottom-0 w-10 sm:w-14 sm:right-5 right-5 md:right-9">
            <img src={img_heart4} alt="heart4"></img>
          </div>
        </div>
      </div>
    </div>
  );
}
